import { is } from '@common/is/is'
import SVGIcon from '@common/components/SVGIcon/SVGIcon'
import DOM from '@common/DOM/DOM'

import type { INavbarButtonProps } from '../../definitions'
import { ENavbarEvent } from '../../definitions'

import './NavbarButton.scss'

/**
 * Navbar komponens gombja.
 * @param props - Props {@link INavbarButtonProps}.
 */
export default function NavbarButton (props: INavbarButtonProps): HTMLElement {
  const { onClick, text = '', type = 'default' } = props

  const btn = (
    <div
      className="sen-navbar__button"
      data-type={ type }
      onClick={ () => {
        if (type === 'side') {
          DOM.dispatch(document, ENavbarEvent.SideButtonClicked)
        }

        onClick()
      } }
    >
      {
        is.empty(text)
          ? null
          : (
            <div className="sen-navbar__button__text">
              { text }
            </div>
          )
      }

      { type === 'hamburger'
        ? <SVGIcon type="menu" />
        : null }
    </div>
  )

  return btn
}
